import { useQueryClient, useMutation } from "@tanstack/react-query";
import WorkService from "../service/WorkService";
import { useNotification } from "../context/NotificationContext";

export function useDeleteWork(workId) {
  const queryClient = useQueryClient();
  const { addNotification } = useNotification();

  const { mutate: deleteWork, isLoading: isDeleting } = useMutation(
    async () => {
      await WorkService.delete(workId);
    },
    {
      onSuccess: () => {
        console.log("Work deleted successfully");
        queryClient.cancelQueries(["worksData"]);

        // Aggiorna localStorage rimuovendo il work appena eliminato
        const savedData = JSON.parse(localStorage.getItem("worksData")) || [];
        const updatedData = savedData?.filter(
          (element) => element.id !== workId,
        );
        localStorage.setItem("worksData", JSON.stringify(updatedData));
        addNotification("Work deleted", "success");
        // Invalida e refetch dei dati
        // Aggiorna lo stato dei dati locali immediatamente
        queryClient.setQueryData(["worksData"], updatedData);
        queryClient.refetchQueries(
          { queryKey: ["worksData"] },
          { cancelRefetch: true },
        );
      },
      onError: (error) => {
        // Gestisci l'errore
        addNotification(error.message, "error");
        console.error("Error deleting work:", error);
      },
    },
  );

  return {
    deleteWork,
    isDeleting,
  };
}
